module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3r2n6r9r-fa93c76ca8187af4d2dced4dd69ede6e.svg";